import { DefaultApi } from '../../../api';
import { urls } from '../../../urls';
import { Action } from '../../../action';
import { getCatchError } from '../../../getCatchError';

const setGetDetalization = (params) => {
    return async (dispatch, getState) => {
        try {
            const { data } = await DefaultApi({
                params,
                method: 'get',
                url: urls.GET_DETALIZATION_INFORMATION
            });

            if (data.status === 'success') {
                dispatch(Action.SetGetDetalizationAction(data.data))
            }

        } catch (error) {
            getCatchError(error)
        }
    }
}

export {
    setGetDetalization as SetGetDetalization
}